<template lang="html">
  <div class="outbound-link">
    <h2>You are about to visit an external url</h2>
    <a class="preview-link" :href="campaignUrl">{{link}}</a>
    <a class="btn is-secondary" :href="campaignUrl">Proceed</a>
  </div>
</template>

<script>
export default {
  name: 'OutboundLink',

  props: {
    link: String
  },

  computed: {
    campaignUrl() {
      return `${this.link}?utm_source=PageMakerPro&utm_medium=dashboard`
    }
  }
}
</script>

<style lang="sass">
  .outbound-link
    padding: 50px
    text-align: center

    .preview-link
      color: rgba(0, 0, 0, 0.3)
      display: block
      margin-bottom: 15px
</style>
